// extracted by mini-css-extract-plugin
export default {"button":"Swap_button__L73IJ"};